<template>
  <div class="common-footer" :class="{ lineup: isLineup }">
    <div class="logo_block">
      <div class="flex">
        <div class="company_info">
          <div v-if="isJP" class="company_title">
            {{ t('株式会社はっち') }}
          </div>
          <div class="company_title">{{ t('DORIMA') }}</div>
          <br />
          <div class="company_detail">{{ t('〒547-0011') }}</div>
          <div class="company_detail">{{ t('大阪府大阪市平野区長吉出戸七丁目3-39') }}</div>
          <br />
          <div class="company_detail">{{ t('TEL：06-6643-9996') }}</div>
        </div>
        <div class="double-flex">
          <ShadowButton
            class="shadow-button"
            :text="`${t('会社概要')} >`"
            @handleShadowBtnClick="goToAboutUs"
          />
          <ShadowButton
            class="shadow-button"
            :text="`${t('利用規約')} >`"
            @handleShadowBtnClick="goToTermsOfService"
          />
          <ShadowButton
            class="shadow-button"
            :text="`${t('資金決済法')} >`"
            @handleShadowBtnClick="goToFundSettlement"
          />
          <ShadowButton
            class="shadow-button"
            :text="`${t('特定商取引法')} >`"
            @handleShadowBtnClick="goToSpecificCommerce"
          />
          <ShadowButton
            class="shadow-button"
            :text="`${t('ご利用ガイド')} >`"
            @handleShadowBtnClick="goToUserGuide"
          />
          <ShadowButton
            class="shadow-button"
            :text="`${t('ポイント利用規約')} >`"
            @handleShadowBtnClick="goToPointTermsOfService"
          />
          <ShadowButton
            class="shadow-button"
            :text="`${t('個人情報保護ポリシー')} >`"
            @handleShadowBtnClick="goToPrivacyProtection"
          />
        </div>
      </div>
      <div class="logo">
        <img src="/img/dorima_logo.png" />
        <div>Copyright © 2026はっち All rights reserved.</div>
      </div>
    </div>
  </div>
</template>

<script>
// import DoubleBorderBox from '@/components/molecules/DoubleBorderBox.vue';
import ShadowButton from '@/components/molecules/ShadowButton.vue';
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';

export default {
  name: 'CommonFooter',

  components: {
    // DoubleBorderBox,
    ShadowButton,
  },

  computed: {
    ...mapGetters({
      currentLanguage: 'user/currentLanguage',
    }),
    isJP() {
      return this.currentLanguage === 'ja';
    },
  },

  props: {
    currentUser: {
      type: Object,
    },
    isLineup: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [t],

  methods: {
    goToLogin() {
      // ログインしていない場合、ログイン画面へ。routerのbeforeEachだとエラーが出る。（リダイレクトはされる）
      // const query = {
      //   packId: this.$route.query.packId,
      // };
      // this.$router.push({
      //   path: '/login',
      //   query: this.$route.query.packId ? query : null,
      // });
      this.$store.dispatch('user/setShowLoginPage', true);
    },
    goToTop() {
      if (this.$route.name === 'Top') {
        return;
      }
      this.$router.push('/');
    },
    goToBuyPoint() {
      if (this.$route.name === 'BuyPoint') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      let url = '/buy-point';
      if (this.$route.params.productId) {
        url += `/${this.$route.params.productId}`;
      }
      this.$router.push(url);
    },
    // goToBuyProductHistory() {
    //   if (this.$route.name === 'BuyProductHistory') {
    //     return;
    //   }
    //   if (this.currentUser.is_login === '0') {
    //     if (this.$route.name === 'UserLogin') {
    //       return;
    //     }
    //     this.goToLogin();
    //     return;
    //   }
    //   this.$router.push('/buy-product-history');
    // },
    goToSpecificCommerce() {
      this.$router.push('/specific-commerce');
    },
    goToTermsOfService() {
      this.$router.push('/terms-of-service');
    },
    goToPrivacyProtection() {
      this.$router.push('/privacy-protection');
    },
    goToUserGuide() {
      this.$router.push('/user-guide');
    },
    goContactUs() {
      window.open(
        'https://minny-online-store.iranoan.com/contacts?service=1',
        '_blank',
      );
    },
    goToAboutUs() {
      window.open('https://www.hatti-op.jp/info', '_blank');
    },
    goToFundSettlement() {
      this.$router.push('/fund-settlement');
    },
    goToPointTermsOfService() {
      this.$router.push('/gem-terms-of-service');
    },
  },
};
</script>

<style lang="scss" scoped>
.common-footer {
  // background-color: #081b40;
  position: absolute;
  bottom: 0;
  width: 100vw;
  padding-bottom: 100px;
  margin: 0 -10px;
  // 上に軽くシャドウをつける
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  &.lineup {
    padding-bottom: 200px;
  }
  .flex {
    display: flex;
    .company_info {
      width: 27%;
      line-height: 1.1;
      margin: 10px 0 0 10px;
      .company_title {
        font-weight: bold;
      }
      .company_detail {
        font-weight: bold;
        font-size: 12px;
      }
    }
    .double-flex {
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      .shadow-button {
        width: 33%;
        padding: 5px 0;
        color: #000 !important;
        font-weight: bold;
        text-align: center;
      }
    }
  }
  .footer-button-area {
    display: none;
  }
  .logo_block {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    max-width: 1200px;
    margin: auto;
    // flex-direction: column;
    .logo {
      // padding: 20px;
      // text-align: right;
      // color: $white;
      padding-left: 9px;
      font-weight: bold;
      color: #000;
      img {
        width: 160px;
      }
      div {
        font-size: 12px;
        width: 325px;
      }
    }
  }
}
.footer {
  background-color: $mainColor;
  color: #fff;
  text-align: center;
  font-size: 12px;
  padding: 0 0 20px 0;
}
.pc {
  display: block;
}
.sp {
  display: none;
}
@media screen and (max-width: $tabletWidth) {
  .common-footer {
    .flex {
      flex-direction: row-reverse;
      .company_info {
        width: 45%;
        margin: 10px 0 0 0;
        text-align: left;
        .company_title {
          font-size: 10px;
        }
        .company_detail {
          font-size: 8px;
        }
      }
      .double-flex {
        padding: 10px;
        .shadow-button {
          width: 50%;
          text-align: unset;
          font-size: 9px;
          word-break: break-word;
          padding: 5px 5px;
        }
      }
    }
    .logo_block {
      flex-direction: column;
      align-items: flex-start;
      .logo {
        text-align: left;
        width: 100%;
        padding: 0 0 20px 0;
        position: relative;
        img {
          // position: absolute;
          bottom: 50px;
          right: 30px;
          width: 160px;
        }
        div {
          text-align: center;
          padding: 0;
        }
      }
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  .common-footer {
    &.lineup {
      padding-bottom: 152px;
    }
  }
}
</style>
